import React from 'react';

export interface TokenCountData {
  promptTokens: number;
}

interface TokenCountProps {
  tokenCount?: TokenCountData;
}

const TokenCount: React.FC<TokenCountProps> = ({ tokenCount }) => {
  if (!tokenCount) return null;

  return (
    <div className="flex rounded pr-1">
      <p className="text-sm text-gray-600">Prompt Tokens: </p>
      <p className="pl-1 text-sm font-semibold text-gray-600">
        {tokenCount.promptTokens}
      </p>
    </div>
  );
};

export default TokenCount;
